<template>
  <div>
    <v-form ref="formCreateCodeReduction" v-model="valid" class="mb-5 mt-4">
      <v-row>
        <v-col md="6" cols="12">
          <label class="field_label">Indiquer le code<span class="text-red">*</span></label>
          <v-text-field v-model="code_reduction.nom" placeholder="Ex : PROMO10"
            @change="code_reduction.nom = code_reduction.nom.toUpperCase()" required ref="field_nom"
            @blur="$refs.field_nom.validate()"
            :rules="[$formRules.code_reduction(code_reduction.nom, list_code_reduction)]"></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label class="field_label">La réduction s'applique sur <span class="text-red">*</span></label>
          <v-select v-model="code_reduction.apply_to" :items="items_apply_to"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12">
          <label class="field_label">Type de réduction<span class="text-red">*</span></label>
          <v-select v-model="code_reduction.type" :items="['Pourcentage', 'Remise en euros']"></v-select>
        </v-col>
        <v-col md="6" cols="12">
          <label class="field_label" v-if="code_reduction.type == 'Pourcentage'">Pourcentage de réduction<span
              class="text-red">*</span></label>
          <label class="field_label" v-else>Remise en euros<span class="text-red">*</span></label>
          <v-text-field type="number" placeholder="Ex : 10" v-model="code_reduction.valeur" required></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12">
          <label class="field_label">Nombre d'utilisation maximum (optionnel)</label>
          <v-text-field type="number" placeholder="Laisser vide pour aucune limite d'utilisation"
            v-model="code_reduction.nb_utilisations_max"></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <label class="field_label">Date d'expiration, ne sera plus valable le jour indiqué (optionnel). </label>
          <v-text-field type="date" v-model="code_reduction.date_validite"></v-text-field>
        </v-col>
      </v-row>
      <div class="d-flex justify-center">
        <v-btn color="primary-dark" @click="validate()">Créer le code</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Code_Reduction from "@/classes/Code_Reduction/Code_Reduction.class";
export default {
  props: ["list_code_reduction"],
  data() {
    return {
      code_reduction: new Code_Reduction(),
      valid: false,
      items_apply_to: [
        { title: "Les courses", value: "courses" },
        { title: "Les options", value: "options" },
        { title: "Les deux", value: "deux" },
      ],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async validate() {
      if (this.$refs.formCreateCodeReduction.validate()) {
        this.code_reduction.id_module = this.mainStore.module.id;
        await this.code_reduction.post();
        this.$router.go();
      }
    },
  },
  created() {
    if (this.mainStore.billetterie_mode) {
      this.items_apply_to = [
        {
          title: "La billetterie",
          value: "options",
        },
      ];
      this.code_reduction.apply_to = "options";
    }
  },
};
</script>

<style lang="scss" scoped></style>